module.exports = __webpack_public_path__ + "static/img/circRNA1.14a6e6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/基因调控/基因干扰/circRNA1.jpg
// module id = trnq
// module chunks = 16